import { createFileRoute } from '@tanstack/react-router';
import { AdminCohortEnroll } from './admin.cohorts.$id.enroll';

export const Route = (createFileRoute as any)('/instructor/cohorts/$id/enroll')({
  component: AdminCohortEnroll,
});
